import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePermissions } from '@/hooks/usePermissions';
import ContratacaoEditTabs from '@/components/ContratacaoEditTabs';
import VerificarStatusClicksign from '@/components/VerificarStatusClicksign';

export default function ContratacaoEdit() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { hasPermission, refetch } = usePermissions();
  const [permissionsChecked, setPermissionsChecked] = useState(false);

  const canWrite = hasPermission('recursos_humanos', 'contratacao', 'write');

  useEffect(() => {
    refetch().then(() => {
      setPermissionsChecked(true);
    });
  }, []);

  useEffect(() => {
    if (!permissionsChecked) return;
    
    if (!canWrite || !id) {
      navigate('/intranet/contratacao');
      return;
    }
  }, [id, canWrite, permissionsChecked]);

  const handleSave = () => {
    navigate(`/intranet/contratacao/${id}/view`);
  };

  const handleCancel = () => {
    navigate(`/intranet/contratacao/${id}/view`);
  };

  if (!permissionsChecked) {
    return <div className="flex justify-center p-8">Carregando...</div>;
  }

  if (!id) {
    return <div className="flex justify-center p-8">ID da contratação não encontrado</div>;
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-4">
          <Button variant="outline" onClick={() => navigate('/intranet/contratacao')}>
            <ArrowLeft className="mr-2 h-4 w-4" />
            Voltar
          </Button>
          <h1 className="text-2xl font-bold">Editar Contratação</h1>
          <VerificarStatusClicksign onVerificacaoCompleta={() => window.location.reload()} />
        </div>
      </div>

      <ContratacaoEditTabs 
        contratacaoId={id}
        onSave={handleSave}
        onCancel={handleCancel}
      />
    </div>
  );
}